import React, { useState, useEffect, useRef } from 'react';
import { API, API_ORIGIN, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import AuctionCountdown from './AuctionCountdown';
import TrustBadge from './TrustBadge';
// AuctionBidModal 제거 — 입찰은 마당(외부 바이어)에서만 (정책 2026-05-25)
import AuctionWinnerSelection from './AuctionWinnerSelection';
import ActiveBiddersList from './ActiveBiddersList';
import AuctionReviewList from './AuctionReviewList';
import TrustScoreDetail from './TrustScoreDetail';
import CarPaintMap from './CarPaintMap';
import DamageCheckMap from './DamageCheckMap';
import MarketPriceCard from './MarketPriceCard';  // W8 — AUTODEX 시세 (ERP 내부)
import AuctionEditModal from './AuctionEditModal';

// 경매 상세 페이지
function AuctionDetail(props){
  var auctionId=props.auctionId;
  var onBack=props.onBack;

  var[auction,setAuction]=useState(null);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');
  var[photoIdx,setPhotoIdx]=useState(0);
  var[showFullscreen,setShowFullscreen]=useState(false);
  var[favLoading,setFavLoading]=useState(false);
  var[trustUserId,setTrustUserId]=useState(null);
  var[showInspectionDetail,setShowInspectionDetail]=useState(false);
  var[showEditModal,setShowEditModal]=useState(false);

  var loadDetail=function(){
    setLoading(true);
    setError('');
    authFetch(API+'/auctions/'+auctionId)
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data&&d.data.auction){
          setAuction(d.data.auction);
        }else{
          setError((d&&d.error)||'경매를 불러올 수 없습니다');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setLoading(false)});
  };

  useEffect(function(){
    loadDetail();
    setPhotoIdx(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auctionId]);

  // 인접 사진 프리로드 — photoIdx가 바뀔 때 prev/next 백그라운드 다운로드
  useEffect(function(){
    if(!auction||!auction.photos||auction.photos.length<2)return;
    var photos=auction.photos;
    var apiBase=API_ORIGIN;
    var resolveUrl=function(raw){
      if(!raw)return '';
      if(raw.indexOf('http')===0)return raw;
      if(raw.charAt(0)==='/')return apiBase+raw;
      return apiBase+'/'+raw;
    };
    var preloadIdx=[(photoIdx+1)%photos.length,(photoIdx-1+photos.length)%photos.length];
    preloadIdx.forEach(function(i){
      var p=photos[i];
      if(!p)return;
      var url=resolveUrl(p.url||p.thumbnail||'');
      if(!url)return;
      var img=new Image();
      img.decoding='async';
      img.src=url;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[photoIdx,auction&&auction.id]);

  // WebSocket 실시간 갱신 — auctionId 필터 + 디바운스 500ms
  var fetchTimerRef=useRef(null);
  useEffect(function(){
    var s=getSocket();
    if(!s||!auctionId)return;
    var refresh=function(payload){
      if(payload&&payload.auctionId&&payload.auctionId!==auctionId)return;
      if(fetchTimerRef.current)clearTimeout(fetchTimerRef.current);
      fetchTimerRef.current=setTimeout(loadDetail,500);
    };
    var events=['auction:bid-received','auction:winner-selected','auction:pending-selection','auction:expired','auction:cancelled','auction:rejected-all'];
    events.forEach(function(ev){s.on(ev,refresh)});
    return function(){
      events.forEach(function(ev){s.off(ev,refresh)});
      if(fetchTimerRef.current)clearTimeout(fetchTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auctionId]);

  var toggleFav=function(){
    if(!auction||favLoading)return;
    setFavLoading(true);
    var prevFav=!!(auction.myStatus&&auction.myStatus.isFavorite);
    var prevCount=(auction.liveStats&&auction.liveStats.favoriteCount)||0;
    // 낙관적
    setAuction(function(a){
      var next=Object.assign({},a);
      next.myStatus=Object.assign({},a.myStatus||{},{isFavorite:!prevFav});
      next.liveStats=Object.assign({},a.liveStats||{},{favoriteCount:prevCount+(!prevFav?1:-1)});
      return next;
    });
    authFetch(API+'/auctions/'+auctionId+'/favorite',{method:'POST'})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          setAuction(function(a){
            var next=Object.assign({},a);
            next.myStatus=Object.assign({},a.myStatus||{},{isFavorite:d.data.isFavorite});
            next.liveStats=Object.assign({},a.liveStats||{},{favoriteCount:d.data.favoriteCount});
            return next;
          });
        }else{
          // 롤백
          setAuction(function(a){
            var next=Object.assign({},a);
            next.myStatus=Object.assign({},a.myStatus||{},{isFavorite:prevFav});
            next.liveStats=Object.assign({},a.liveStats||{},{favoriteCount:prevCount});
            return next;
          });
        }
      })
      .catch(function(){})
      .then(function(){setFavLoading(false)});
  };

  var handleCloseEarly=function(){
    if(!window.confirm('경매를 지금 마감하시겠습니까?\n남은 시간이 있어도 즉시 입찰이 종료됩니다.'))return;
    authFetch(API+'/auctions/'+auctionId+'/close-early',{method:'POST'}).then(function(r){return r.json()}).then(function(d){if(d&&d.success)loadDetail();else window.alert((d&&d.error)||'마감 실패')}).catch(function(){window.alert('서버 연결 실패')});
  };

  // ────────── 렌더 시작 ──────────
  if(loading&&!auction){
    return (
      <div style={{padding:'20px 24px',maxWidth:900,margin:'0 auto'}}>
        <button onClick={onBack}
          style={{background:'none',border:'none',color:'#1B3A5C',fontSize:13,fontWeight:600,cursor:'pointer',padding:'8px 0',marginBottom:16}}>← 목록으로</button>
        <div style={{padding:60,textAlign:'center',color:'#94a3b8'}}>불러오는 중...</div>
      </div>
    );
  }

  if(error||!auction){
    return (
      <div style={{padding:'20px 24px',maxWidth:900,margin:'0 auto'}}>
        <button onClick={onBack}
          style={{background:'none',border:'none',color:'#1B3A5C',fontSize:13,fontWeight:600,cursor:'pointer',padding:'8px 0',marginBottom:16}}>← 목록으로</button>
        <div style={{padding:'40px 20px',textAlign:'center',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:12,color:'#dc2626',fontSize:14}}>
          ⚠ {error||'경매를 찾을 수 없습니다'}
        </div>
      </div>
    );
  }

  var photos=auction.photos||[];
  var inspection=auction.inspection||{};
  var myStatus=auction.myStatus||{};
  var liveStats=auction.liveStats||{};
  var seller=auction.seller||{}, ci=auction.contactInfo;

  var currentPhoto=photos[photoIdx];
  var photoUrl='';
  if(currentPhoto){
    var raw=currentPhoto.url||currentPhoto.thumbnail||'';
    if(raw.indexOf('http')===0)photoUrl=raw;
    else if(raw.charAt(0)==='/')photoUrl=API_ORIGIN+raw;
    else photoUrl=API_ORIGIN+'/'+raw;
  }
  // 2026-04-29: 엔진 동영상 등 비디오 파일 분기 — 평가 → 매입 → 경매 carry-over (eval-orders.js:365)
  var VIDEO_RE=/\.(mp4|mov|avi|webm|3gp)$/i;
  var isVideo=function(p){if(!p)return false;return VIDEO_RE.test(p.filename||p.url||'')};
  var currentIsVideo=isVideo(currentPhoto);

  var isFav=!!myStatus.isFavorite;
  var favCount=liveStats.favoriteCount||0;

  var status=auction.status;
  var isActive=status==='active';
  var isPending=status==='pending_selection';
  var isSold=status==='sold';
  var isEnded=(auction.timeRemaining&&auction.timeRemaining.isEnded)||!isActive;
  var isMine=!!auction.isMyAuction;

  var yearLabel=auction.car&&auction.car.year?auction.car.year+'년 ':'';
  var modelLabel=(auction.car&&auction.car.model)||auction.title||'경매 차량';

  var prevPhoto=function(){setPhotoIdx(function(i){return i>0?i-1:photos.length-1})};
  var nextPhoto=function(){setPhotoIdx(function(i){return i<photos.length-1?i+1:0})};

  return (
    <div style={{maxWidth:900,margin:'0 auto',paddingBottom:100,background:'#f8fafc',minHeight:'100%'}}>
      {/* 상단 바 */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'16px 20px',background:'#fff',borderBottom:'1px solid #e5e7eb',position:'sticky',top:0,zIndex:10}}>
        <button onClick={onBack}
          style={{background:'none',border:'none',color:'#1B3A5C',fontSize:14,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:6}}>
          <span style={{fontSize:18}}>←</span><span>목록으로</span>
        </button>
        <button onClick={toggleFav} disabled={favLoading}
          style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:isFav?'#fef2f2':'#f1f5f9',border:'1px solid '+(isFav?'#fecaca':'#e2e8f0'),borderRadius:20,cursor:favLoading?'wait':'pointer',fontSize:13,fontWeight:600,color:isFav?'#ef4444':'#64748b'}}>
          <span style={{fontSize:16}}>{isFav?'♥':'♡'}</span><span>{favCount}</span>
        </button>
      </div>

      {/* 상태 배너 */}
      {isPending&&<div style={{background:'#fbbf24',color:'#78350f',padding:'10px 20px',fontSize:13,fontWeight:700,textAlign:'center'}}>🏆 낙찰자 선택 중 — 출품자가 최종 낙찰자를 고르고 있습니다</div>}
      {isSold&&<div style={{background:'#10b981',color:'#fff',padding:'10px 20px',fontSize:13,fontWeight:700,textAlign:'center'}}>✓ 낙찰 완료</div>}
      {(status==='failed'||status==='rejected_all'||status==='expired_selection'||status==='cancelled')&&<div style={{background:'#64748b',color:'#fff',padding:'10px 20px',fontSize:13,fontWeight:700,textAlign:'center'}}>{status==='failed'?'유찰':status==='rejected_all'?'전체 거절':status==='expired_selection'?'선택 기한 만료':'취소됨'}</div>}

      {/* 출품자 전용: 낙찰자 선택 화면 */}
      {isPending&&isMine&&(
        <AuctionWinnerSelection auctionId={auctionId} onComplete={loadDetail}/>
      )}

      {/* A-1 — 출품자 1-click 재출품 (rejected_all / cancelled) */}
      {isMine&&(status==='rejected_all'||status==='cancelled')&&(
        <RelistPanel auctionId={auctionId}/>
      )}

      {/* 2026-05-10 — 출품자 전용: 진행 중 입찰자 list (즉시 마감 결정 도구) */}
      {isActive&&isMine&&(
        <div style={{padding:'14px 20px',background:'#fff',borderBottom:'1px solid #e5e7eb'}}>
          <ActiveBiddersList auctionId={auctionId} refreshKey={liveStats.bidCount||0}/>
        </div>
      )}

      {/* 사진 갤러리 */}
      <div style={{position:'relative',width:'100%',background:'#0f172a',overflow:'hidden'}}>
        <div style={{position:'relative',width:'100%',paddingTop:'56.25%'}}>
          {photoUrl?(
            currentIsVideo?(
              <video src={photoUrl} controls preload="metadata"
                style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',objectFit:'contain',background:'#000'}}/>
            ):(
              <img src={photoUrl} alt={modelLabel}
                fetchpriority="high" decoding="async"
                onClick={function(){setShowFullscreen(true)}}
                style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',objectFit:'contain',cursor:'zoom-in'}}
                onError={function(e){e.currentTarget.style.display='none'}}/>
            )
          ):(
            <div style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:72,color:'#475569'}}>🚗</div>
          )}
          {photos.length>1&&(
            <div>
              <button onClick={prevPhoto}
                style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',width:40,height:40,borderRadius:'50%',border:'none',background:'rgba(0,0,0,0.55)',color:'#fff',fontSize:20,cursor:'pointer',fontWeight:700}}>‹</button>
              <button onClick={nextPhoto}
                style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',width:40,height:40,borderRadius:'50%',border:'none',background:'rgba(0,0,0,0.55)',color:'#fff',fontSize:20,cursor:'pointer',fontWeight:700}}>›</button>
              <div style={{position:'absolute',bottom:12,left:'50%',transform:'translateX(-50%)',padding:'4px 10px',background:'rgba(0,0,0,0.6)',color:'#fff',borderRadius:12,fontSize:11,fontWeight:600}}>
                {photoIdx+1} / {photos.length}
              </div>
            </div>
          )}
        </div>
        {/* 썸네일 스트립 */}
        {photos.length>1&&(
          <div style={{display:'flex',gap:4,padding:'8px 12px',overflowX:'auto',background:'#1e293b'}}>
            {photos.map(function(p,i){
              var thumbRaw=p.thumbnail||p.url||'';
              var thumbUrl=thumbRaw.indexOf('http')===0?thumbRaw:thumbRaw.charAt(0)==='/'?API_ORIGIN+thumbRaw:API_ORIGIN+'/'+thumbRaw;
              var thumbIsVideo=isVideo(p);
              return (
                <div key={i} onClick={function(){setPhotoIdx(i)}}
                  style={{position:'relative',flex:'0 0 auto',width:60,height:42,borderRadius:4,overflow:'hidden',cursor:'pointer',border:i===photoIdx?'2px solid #fff':'2px solid transparent',opacity:i===photoIdx?1:0.6,background:thumbIsVideo?'#0f172a':'transparent'}}>
                  {thumbUrl&&!thumbIsVideo&&<img src={thumbUrl} alt="" loading="lazy" decoding="async" style={{width:'100%',height:'100%',objectFit:'cover'}}/>}
                  {thumbIsVideo&&<div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:18}}>▶</div>}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* 제목 + 기본 정보 */}
      <div style={{padding:'18px 20px',background:'#fff'}}>
        <div style={{fontSize:22,fontWeight:800,color:'#0f172a'}}>{yearLabel}{modelLabel}</div>
        <div style={{fontSize:13,color:'#64748b',marginTop:6,display:'flex',flexWrap:'wrap',gap:8}}>
          {auction.car&&auction.car.mileage>0&&<span>{Number(auction.car.mileage).toLocaleString()} km</span>}
          {auction.car&&auction.car.number&&<span>· {auction.car.number}</span>}
          {auction.car&&auction.car.vin&&<span>· VIN {String(auction.car.vin).slice(-6)}</span>}
        </div>
        {/* W8 — AUTODEX 시세 (한국 직원, KRW) */}
        {auction.car && <MarketPriceCard model={auction.car.model} year={auction.car.year} mileage={auction.car.mileage} locale="ko" />}
      </div>

      {/* 검차 정보 */}
      <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
        <div style={{fontSize:12,fontWeight:700,color:'#64748b',marginBottom:10}}>검차 정보</div>
        {inspection.hasInspection?(
          <div>
            <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
              <div style={{padding:'6px 14px',background:inspection.summaryColor||'#94a3b8',color:'#fff',borderRadius:6,fontSize:13,fontWeight:700}}>
                {inspection.summary||'검차없음'}
              </div>
              {inspection.score>0&&(
                <div style={{fontSize:13,color:'#475569'}}>
                  종합 점수 <strong style={{color:'#0f172a',fontSize:15}}>{inspection.score}</strong>/100
                </div>
              )}
              <div style={{fontSize:11,color:'#94a3b8',marginLeft:'auto'}}>
                도막 {inspection.paintMap?Object.keys(inspection.paintMap).filter(function(k){return inspection.paintMap[k]}).length:0}곳 · 사진 {inspection.photoCount||0}장
              </div>
            </div>

            {/* 접이식 토글 */}
            <button onClick={function(){setShowInspectionDetail(!showInspectionDetail)}}
              style={{marginTop:12,width:'100%',padding:'10px 0',background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:8,fontSize:12,fontWeight:700,color:'#475569',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}>
              <span>🔍 검차 상세 {showInspectionDetail?'숨기기':'보기'}</span>
              <span style={{fontSize:10}}>{showInspectionDetail?'▲':'▼'}</span>
            </button>

            {/* 상세: 도막맵 + 사고부위 4면도 */}
            {showInspectionDetail&&(
              <div style={{marginTop:12,display:'flex',flexDirection:'column',gap:14}}>
                {/* 도막 측정 */}
                <div style={{padding:'14px 12px',background:'#f8fafc',borderRadius:10,border:'1px solid #e2e8f0'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:10,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <span>🎨 도막 측정</span>
                    <span style={{fontSize:9,color:'#94a3b8',fontWeight:500}}>&lt;150 정상 · 150~249 의심 · ≥250 판금</span>
                  </div>
                  {inspection.paintMap&&Object.keys(inspection.paintMap).filter(function(k){return inspection.paintMap[k]}).length>0?(
                    <div style={{display:'flex',justifyContent:'center'}}>
                      <CarPaintMap data={inspection.paintMap} width={320}/>
                    </div>
                  ):(
                    <div style={{padding:14,textAlign:'center',fontSize:11,color:'#94a3b8'}}>도막 측정 데이터 없음</div>
                  )}
                </div>

                {/* 사고 부위 4면도 */}
                <div style={{padding:'14px 12px',background:'#f8fafc',borderRadius:10,border:'1px solid #e2e8f0'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#475569',marginBottom:10}}>🔧 사고 부위 (4면도)</div>
                  {inspection.damageMap&&Object.keys(inspection.damageMap).length>0?(
                    <DamageCheckMap value={inspection.damageMap} readOnly={true}/>
                  ):(
                    <div style={{padding:14,textAlign:'center',fontSize:12,color:'#10b981',fontWeight:700}}>✅ 사고 이력 없음</div>
                  )}
                </div>
              </div>
            )}
          </div>
        ):(
          <div style={{padding:'10px 12px',background:'#f1f5f9',borderRadius:6,fontSize:12,color:'#94a3b8',textAlign:'center'}}>
            검차 정보가 없습니다
          </div>
        )}
      </div>

      {/* 경매 정보 */}
      <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
        <div style={{fontSize:12,fontWeight:700,color:'#64748b',marginBottom:10}}>경매 정보</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          {myStatus.hasBid&&isActive?(
            <div style={{padding:'12px',background:'#eff6ff',borderRadius:8,border:'1px solid #bfdbfe'}}>
              <div style={{fontSize:10,color:'#94a3b8'}}>내 입찰</div>
              <div style={{fontSize:17,fontWeight:800,color:'#1B3A5C',marginTop:2}}>{Math.round((myStatus.myAmount||0)/10000).toLocaleString()}<span style={{fontSize:12,marginLeft:2}}>만원</span></div>
              {myStatus.myRank>0&&<div style={{fontSize:10,color:myStatus.isHighest?'#10b981':'#94a3b8',marginTop:2,fontWeight:700}}>{myStatus.myRank}위 / {myStatus.totalBids}명</div>}
            </div>
          ):(
            <div style={{padding:'12px',background:'#f8fafc',borderRadius:8}}>
              <div style={{fontSize:10,color:'#94a3b8'}}>입찰 건수</div>
              <div style={{fontSize:17,fontWeight:800,color:'#475569',marginTop:2}}>{liveStats.bidCount||0}<span style={{fontSize:12,marginLeft:2}}>건</span></div>
            </div>
          )}
        </div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:12,padding:'10px 12px',background:'#f8fafc',borderRadius:8,fontSize:12,color:'#475569'}}>
          <span>👁 조회 {liveStats.viewCount||0}</span>
          <span>🔨 입찰 {liveStats.bidCount||0}</span>
          <span>♡ 관심 {favCount}</span>
        </div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10,padding:'10px 12px',background:'#fff7ed',borderRadius:8,border:'1px solid #fed7aa'}}>
          <span style={{fontSize:12,color:'#9a3412',fontWeight:700}}>남은 시간</span>
          <AuctionCountdown timeRemaining={auction.timeRemaining} size="md" onExpired={loadDetail}/>
        </div>
      </div>

      {/* 낙찰 후 연락처 카드 — 출품자↔낙찰자 양방향 */}
      {isSold&&ci&&(
        <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
          <div style={{fontSize:12,fontWeight:700,color:'#64748b',marginBottom:10}}>📞 {ci.role==='seller'?'출품자':'낙찰자'} 연락처</div>
          <div style={{padding:'14px',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:10}}>
            <div style={{fontSize:14,fontWeight:800,color:'#0f172a'}}>{ci.companyName||'(업체명 없음)'}{ci.name?' · '+ci.name:''}</div>
            {ci.address&&<div style={{fontSize:11,color:'#475569',marginTop:4}}>📍 {ci.address}</div>}
            <div style={{display:'flex',gap:8,marginTop:10}}>
              {ci.phone?<a href={'tel:'+ci.phone} style={{flex:1,padding:'10px 0',background:'#1D9E75',color:'#fff',borderRadius:8,fontSize:13,fontWeight:700,textDecoration:'none',textAlign:'center'}}>📞 {ci.phone}</a>:<div style={{flex:1,padding:'10px 0',background:'#f1f5f9',color:'#94a3b8',borderRadius:8,fontSize:12,fontWeight:700,textAlign:'center'}}>연락처 미등록</div>}
              {ci.address&&<a href={'https://map.kakao.com/?q='+encodeURIComponent(ci.address)} target="_blank" rel="noopener noreferrer" style={{flex:1,padding:'10px 0',background:'#3B82F6',color:'#fff',borderRadius:8,fontSize:13,fontWeight:700,textDecoration:'none',textAlign:'center'}}>🗺 카카오맵</a>}
            </div>
          </div>
        </div>
      )}

      {/* B5.3b — 출품자 인계 안내 (sold/pending_selection + 출품자 본인만) */}
      {isMine&&(isSold||isPending)&&(
        <PickupNoteEditor
          auctionId={auctionId}
          initialNote={auction.pickup_note||''}
          onSaved={loadDetail}/>
      )}

      {/* B5.4b — 출품자 ↔ 낙찰자 1:1 채팅 (sold + 출품자 본인) */}
      {isMine&&isSold&&(
        <SellerChatPanel auctionId={auctionId}/>
      )}

      {/* 출품자 */}
      <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
        <div style={{fontSize:12,fontWeight:700,color:'#64748b',marginBottom:10}}>출품자</div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:10}}>
          <div style={{fontSize:14,fontWeight:700,color:'#0f172a',flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
            {seller.displayName||'출품업체'}
          </div>
          {seller.trustBadge&&(
            auction.seller_user_id?(
              <span onClick={function(){setTrustUserId(auction.seller_user_id)}} style={{cursor:'pointer'}} title="신뢰도 상세 보기">
                <TrustBadge badge={seller.trustBadge} size="md"/>
              </span>
            ):(
              <TrustBadge badge={seller.trustBadge} size="md"/>
            )
          )}
        </div>
        {(seller.totalSells>0||seller.avgScore>0)&&(
          <div style={{display:'flex',gap:16,marginTop:8,fontSize:11,color:'#64748b'}}>
            {seller.totalSells>0&&<span>거래 {seller.totalSells}건</span>}
            {seller.avgScore>0&&<span>평점 ⭐ {Number(seller.avgScore).toFixed(1)}</span>}
          </div>
        )}
      </div>

      {/* 설명/메모 */}
      {auction.description&&(
        <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
          <div style={{fontSize:12,fontWeight:700,color:'#64748b',marginBottom:8}}>출품자 메모</div>
          <div style={{fontSize:13,color:'#334155',lineHeight:1.7,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
            {auction.description}
          </div>
        </div>
      )}

      {/* 거래 후기 (sold 상태일 때만) */}
      {isSold&&(
        <AuctionReviewList
          auction={auction}
          canWrite={isMine||!!auction.winner_user_id}
          onReviewSubmitted={loadDetail}/>
      )}

      {/* Sticky 하단 입찰 바 */}
      <div style={{position:'fixed',bottom:0,left:0,right:0,background:'#fff',borderTop:'1px solid #e5e7eb',boxShadow:'0 -4px 16px rgba(0,0,0,0.08)',padding:'12px 20px',zIndex:50}}>
        <div style={{maxWidth:900,margin:'0 auto',display:'flex',alignItems:'center',gap:12}}>
          {isMine?(
            isActive&&liveStats.bidCount===0?(
              <button onClick={function(){setShowEditModal(true)}}
                style={{flex:1,padding:'13px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:'pointer',boxShadow:'0 2px 8px rgba(27,58,92,0.25)'}}>
                ✏️ 내 출품 경매 수정
              </button>
            ):isActive&&liveStats.bidCount>0?(
              <button onClick={handleCloseEarly} style={{flex:1,padding:'13px',background:'#EF9F27',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:'pointer',boxShadow:'0 2px 8px rgba(239,159,39,0.3)'}}>⚡ 즉시 마감 (입찰 {liveStats.bidCount}건)</button>
            ):(
              <div style={{flex:1,padding:'13px',textAlign:'center',background:'#f1f5f9',borderRadius:8,fontSize:13,fontWeight:700,color:'#64748b'}}>
                내가 출품한 경매입니다
              </div>
            )
          ):isEnded||!isActive?(
            <div style={{flex:1,padding:'13px',textAlign:'center',background:'#f1f5f9',borderRadius:8,fontSize:13,fontWeight:700,color:'#94a3b8'}}>
              {isSold?'낙찰 완료된 경매':isPending?'낙찰자 선택 중':'마감된 경매'}
            </div>
          ):(
            // 입찰은 외부 바이어 앱(마당)에서만 — 내부 직원 입찰 비활성 (정책 2026-05-25)
            <div style={{flex:1,padding:'13px',textAlign:'center',background:'#eff6ff',borderRadius:8,fontSize:13,fontWeight:700,color:'#1B3A5C'}}>
              입찰은 바이어 앱(마당)에서만 가능합니다
            </div>
          )}
        </div>
      </div>

      {/* 풀스크린 사진/비디오 모달 */}
      {showFullscreen&&photoUrl&&(
        <div onClick={function(){setShowFullscreen(false)}}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.92)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:20}}>
          {currentIsVideo?(
            <video src={photoUrl} controls autoPlay onClick={function(e){e.stopPropagation()}}
              style={{maxWidth:'100%',maxHeight:'100%',objectFit:'contain',background:'#000'}}/>
          ):(
            <img src={photoUrl} alt=""
              style={{maxWidth:'100%',maxHeight:'100%',objectFit:'contain'}}/>
          )}
          <button onClick={function(e){e.stopPropagation();setShowFullscreen(false)}}
            style={{position:'absolute',top:20,right:20,width:40,height:40,borderRadius:'50%',border:'none',background:'rgba(255,255,255,0.15)',color:'#fff',fontSize:20,cursor:'pointer'}}>✕</button>
          {photos.length>1&&(
            <div>
              <button onClick={function(e){e.stopPropagation();prevPhoto()}}
                style={{position:'absolute',left:20,top:'50%',transform:'translateY(-50%)',width:48,height:48,borderRadius:'50%',border:'none',background:'rgba(255,255,255,0.15)',color:'#fff',fontSize:24,cursor:'pointer'}}>‹</button>
              <button onClick={function(e){e.stopPropagation();nextPhoto()}}
                style={{position:'absolute',right:20,top:'50%',transform:'translateY(-50%)',width:48,height:48,borderRadius:'50%',border:'none',background:'rgba(255,255,255,0.15)',color:'#fff',fontSize:24,cursor:'pointer'}}>›</button>
            </div>
          )}
        </div>
      )}

      {/* 입찰 모달 제거 — 입찰은 마당(외부 바이어)에서만 (정책 2026-05-25) */}

      {/* 신뢰도 상세 모달 */}
      {trustUserId&&(
        <TrustScoreDetail
          userId={trustUserId}
          onClose={function(){setTrustUserId(null)}}/>
      )}

      {/* 경매 수정 모달 */}
      {showEditModal&&(
        <AuctionEditModal
          auction={auction}
          onClose={function(){setShowEditModal(false)}}
          onSuccess={function(){setShowEditModal(false);loadDetail()}}/>
      )}
    </div>
  );
}

/**
 * B5.3b — 출품자 인계 안내 (sold/pending_selection 단계에서 작성)
 * Kyle 결정: 자유 텍스트 단일 필드 (지역/시간/연락처 등 자유 작성)
 * 500자 제한 (백엔드 slice).
 */
function PickupNoteEditor(props){
  var auctionId=props.auctionId;
  var initialNote=props.initialNote||'';
  var onSaved=props.onSaved;
  var[note,setNote]=useState(initialNote);
  var[saving,setSaving]=useState(false);
  var[error,setError]=useState('');
  var[savedMsg,setSavedMsg]=useState('');
  var dirty=note!==initialNote;
  var save=function(){
    if(saving)return;
    setSaving(true);setError('');setSavedMsg('');
    authFetch(API+'/auctions/'+auctionId+'/pickup-note',{
      method:'PUT',
      body:JSON.stringify({pickupNote:note}),
    })
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          setSavedMsg('저장됨');
          if(onSaved)onSaved();
        }else{
          setError((d&&d.error)||'저장 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setSaving(false)});
  };
  return (
    <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
      <div style={{fontSize:12,fontWeight:700,color:'#64748b',marginBottom:10}}>
        🚚 인계 안내 (낙찰자에게 노출)
      </div>
      <div style={{padding:'14px',background:'#fffbeb',border:'1px solid #fde68a',borderRadius:10}}>
        <textarea
          value={note}
          onChange={function(e){setNote(e.target.value.slice(0,500))}}
          placeholder="예) 인천 부평구 부평대로 123. 평일 9~18시. 인계 1일 전 010-1234-5678 로 연락 부탁드립니다."
          rows={4}
          style={{width:'100%',padding:10,border:'1px solid #e5e7eb',borderRadius:8,fontSize:13,fontFamily:'inherit',resize:'vertical',boxSizing:'border-box'}}
        />
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:8}}>
          <div style={{fontSize:11,color:'#94a3b8'}}>{note.length}/500</div>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            {error&&<div style={{fontSize:11,color:'#dc2626',fontWeight:600}}>{error}</div>}
            {savedMsg&&!dirty&&<div style={{fontSize:11,color:'#10b981',fontWeight:600}}>✓ {savedMsg}</div>}
            <button
              onClick={save}
              disabled={saving||!dirty}
              style={{padding:'8px 16px',background:dirty?'#1B3A5C':'#cbd5e1',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:dirty?'pointer':'default'}}>
              {saving?'저장 중...':'저장'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * B5.4b — 출품자 ↔ 낙찰자 1:1 채팅 패널 (sold 단계).
 * REST-only — polling-on-mount + manual refresh + send.
 * 미읽음 채팅은 GET 시 PATCH read 자동 호출 (poll → 표시 → 표시 후 read).
 */
function SellerChatPanel(props){
  var auctionId=props.auctionId;
  var[items,setItems]=useState([]);
  var[unread,setUnread]=useState(0);
  var[loading,setLoading]=useState(false);
  var[chatShowOrig,setChatShowOrig]=useState({});  // TW-W2 — 메시지별 원문 토글
  var[draft,setDraft]=useState('');
  var[sending,setSending]=useState(false);
  var[error,setError]=useState('');

  var fetchMessages=function(){
    setLoading(true);
    setError('');
    authFetch(API+'/auctions/'+auctionId+'/messages?limit=50')
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          var arr=(d.data.items||[]).slice().reverse();   // oldest first (chat order)
          setItems(arr);
          setUnread(d.data.unreadCount||0);
          // 보이는 즉시 read 처리 (unread > 0 일 때만)
          if((d.data.unreadCount||0)>0){
            authFetch(API+'/auctions/'+auctionId+'/messages/read',{method:'PATCH'})
              .then(function(){setUnread(0)}).catch(function(){});
          }
        }else{
          setError((d&&d.error)||'채팅 불러오기 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setLoading(false)});
  };

  useEffect(function(){fetchMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auctionId]);

  var send=function(){
    var body=draft.trim();
    if(!body||sending)return;
    setSending(true);setError('');
    authFetch(API+'/auctions/'+auctionId+'/messages',{
      method:'POST',
      body:JSON.stringify({body:body.slice(0,2000)}),
    })
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          setDraft('');
          fetchMessages();   // 새 메시지 보이게 reload
        }else{
          setError((d&&d.error)||'전송 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setSending(false)});
  };

  return (
    <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
        <div style={{fontSize:12,fontWeight:700,color:'#64748b'}}>
          {'💬 낙찰자 채팅'}
          {unread>0&&<span style={{marginLeft:8,padding:'2px 8px',background:'#ef4444',color:'#fff',borderRadius:10,fontSize:10,fontWeight:800}}>{unread}</span>}
        </div>
        <button onClick={fetchMessages} disabled={loading} style={{padding:'4px 10px',background:'#fff',border:'1px solid #d0d5dd',borderRadius:6,fontSize:11,fontWeight:600,color:'#475569',cursor:loading?'default':'pointer'}}>{loading?'⟳':'새로고침'}</button>
      </div>

      <div style={{maxHeight:300,overflowY:'auto',padding:12,background:'#f8fafc',border:'1px solid #e5e7eb',borderRadius:10,marginBottom:10,display:'flex',flexDirection:'column',gap:8}}>
        {items.length===0&&!loading&&(
          <div style={{textAlign:'center',color:'#94a3b8',fontSize:12,padding:20}}>{'아직 메시지가 없습니다. 낙찰자와 첫 대화를 시작해보세요.'}</div>
        )}
        {items.map(function(m){
          var mine=m.isMine;
          return (
            <div key={m.id} style={{display:'flex',justifyContent:mine?'flex-end':'flex-start'}}>
              <div style={{maxWidth:'75%'}}>
                <div style={{fontSize:10,color:'#94a3b8',marginBottom:2,textAlign:mine?'right':'left'}}>
                  {mine?'내 메시지':m.senderName||'낙찰자'} · {(m.createdAt||'').slice(11,16)}
                </div>
                <div style={{padding:'8px 12px',background:mine?'#1B3A5C':'#fff',color:mine?'#fff':'#0f172a',border:mine?'none':'1px solid #e5e7eb',borderRadius:12,fontSize:13,lineHeight:1.5,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
                  {(m.bodyTranslated&&!chatShowOrig[m.id])?m.bodyTranslated:m.body}
                </div>
                {m.bodyTranslated&&(
                  <button onClick={function(){setChatShowOrig(function(p){var n=Object.assign({},p);n[m.id]=!n[m.id];return n})}}
                    style={{marginTop:3,border:'none',background:'none',padding:0,fontSize:10,color:'#3b82f6',cursor:'pointer',textDecoration:'underline',textAlign:mine?'right':'left',display:'block',width:'100%'}}>
                    🌐 {chatShowOrig[m.id]?'번역 보기':'원문 보기'}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{display:'flex',gap:8}}>
        <textarea
          value={draft}
          onChange={function(e){setDraft(e.target.value.slice(0,2000))}}
          placeholder={'낙찰자에게 메시지 보내기 (인계 일정 등)'}
          rows={2}
          style={{flex:1,padding:10,border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,fontFamily:'inherit',resize:'vertical',boxSizing:'border-box'}}
        />
        <button onClick={send} disabled={!draft.trim()||sending} style={{padding:'10px 16px',background:draft.trim()&&!sending?'#1B3A5C':'#cbd5e1',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:draft.trim()&&!sending?'pointer':'default'}}>{sending?'전송 중...':'전송'}</button>
      </div>
      {error&&<div style={{marginTop:6,fontSize:11,color:'#dc2626',fontWeight:600}}>{error}</div>}
      <div style={{marginTop:6,textAlign:'right',fontSize:10,color:'#94a3b8'}}>{draft.length}/2000</div>
    </div>
  );
}

/**
 * A-1 — 1-click 재출품 패널 (rejected_all / cancelled 출품자 본인).
 * POST /auctions/:id/relist → 새 active 경매 INSERT → navigate to new.
 */
function RelistPanel(props){
  var auctionId=props.auctionId;
  var[submitting,setSubmitting]=useState(false);
  var[error,setError]=useState('');
  var doRelist=function(){
    if(!window.confirm('동일 차량으로 새 경매를 시작합니다 (7일 마감). 계속할까요?'))return;
    setSubmitting(true);setError('');
    authFetch(API+'/auctions/'+auctionId+'/relist',{method:'POST',body:JSON.stringify({})})
      .then(function(r){return r.json()})
      .then(function(d){
        setSubmitting(false);
        if(d&&d.success&&d.data&&d.data.newAuctionId){
          window.location.href='/main/auctions/'+d.data.newAuctionId;
        }else{
          setError((d&&d.error)||'재출품 실패');
        }
      })
      .catch(function(){setSubmitting(false);setError('서버 연결 실패')});
  };
  return (
    <div style={{padding:'14px 20px',background:'#fffbeb',borderBottom:'1px solid #fde68a'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12}}>
        <div style={{flex:1}}>
          <div style={{fontSize:13,fontWeight:700,color:'#92400e',marginBottom:4}}>{'🔁 동일 차량으로 재출품'}</div>
          <div style={{fontSize:11,color:'#78350f'}}>{'사진 / 스펙 / 검사 정보 그대로, 7일 마감으로 새 경매 시작'}</div>
        </div>
        <button onClick={doRelist} disabled={submitting} style={{padding:'10px 18px',background:submitting?'#94a3b8':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:submitting?'default':'pointer'}}>
          {submitting?'재출품 중...':'🔁 재출품'}
        </button>
      </div>
      {error&&<div style={{marginTop:6,fontSize:11,color:'#dc2626',fontWeight:600}}>{error}</div>}
    </div>
  );
}

export default AuctionDetail;
